import {throttle} from "@/utils/index.js"
export default {
	data() {
		return {
			// scrollTop: null,
			tabType: "shouye",
			isSmoothScrolling: false
		}
	},
	mounted() {
		//基准offset-first 模块
		const {first, second, third, fourth, fifth} = this.$refs
		const {offsetTop: firstOffsetTop} = first.$el
		//节流时间间隔
		const THROTTLE_INTERVAL = 200
		this.throttleScroll = throttle(() => {
			//正在平滑滚动，无需监听
			// console.log(`scroll监听:${this.isSmoothScrolling}****`);
			if (this.isSmoothScrolling) return

			//当前的滚动距离
			const scrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop
			const {offsetTop: secondOffsetTop} = second != undefined ? second.$el : 0
			const {offsetTop: thirdOffsetTop} = third.$el
			const {offsetTop: fourthOffsetTop} = fourth.$el
			const {offsetTop: fifthOffsetTop} = fifth.$el

			//scroll计算当前的activeTab
			this.scrollCalcCurrentActiveTab({
				scrollTop,
				firstOffsetTop,
				secondOffsetTop,
				thirdOffsetTop,
				fourthOffsetTop,
				fifthOffsetTop
			})
		}, THROTTLE_INTERVAL)
		window.addEventListener(
			"scroll",
			!this.isSmoothScrolling && this.throttleScroll
		)
		// let touchMove=function(){
		//   debugger
		// }
		// window.addEventListener("touchmove", touchMove, { passive: false });
		window.addEventListener(
			"mouseup",

			throttle(() => {
				this.$nextTick(function () {
					if (this.isSmoothScrolling) this.isSmoothScrolling = false
				})
			}, 500)
		)
	},
	methods: {
		// throttleScroll(THROTTLE_INTERVAL){
		//   console.log("999999")
		//   // throttle(() => {
		//   //   //正在平滑滚动，无需监听
		//   //   if (this.isSmoothScrolling) return;
		//   //   //当前的滚动距离
		//   //   const scrollTop =
		//   //     window.pageYOffset ||
		//   //     document.documentElement.scrollTop ||
		//   //     document.body.scrollTop;
		//   //   const { offsetTop: secondOffsetTop } = second.$el;
		//   //   const { offsetTop: thirdOffsetTop } = third.$el;
		//   //   const { offsetTop: fourthOffsetTop } = fourth.$el;
		//   //   const { offsetTop: fifthOffsetTop } = fifth.$el;

		//   //   //scroll计算当前的activeTab
		//   //   this.scrollCalcCurrentActiveTab({
		//   //     scrollTop,
		//   //     firstOffsetTop,
		//   //     secondOffsetTop,
		//   //     thirdOffsetTop,
		//   //     fourthOffsetTop,
		//   //     fifthOffsetTop,
		//   //   });
		//   // }, THROTTLE_INTERVAL)
		// },
		//scroll计算当前的activeTab
		scrollCalcCurrentActiveTab({
			scrollTop,
			firstOffsetTop,
			secondOffsetTop,
			thirdOffsetTop,
			fourthOffsetTop,
			fifthOffsetTop
		}) {
			//此处向上取整，因为offsetTop获取的是整数，这会导致滚动时tab位置错误
			const currentOffsetTop = firstOffsetTop + Math.ceil(scrollTop)

			if (currentOffsetTop < secondOffsetTop) {
				this.tabType = "shouye"
			} else if (
				currentOffsetTop >= secondOffsetTop &&
				currentOffsetTop < thirdOffsetTop
			) {
				this.tabType = "activity"
			} else if (
				currentOffsetTop >= thirdOffsetTop &&
				currentOffsetTop < fourthOffsetTop
			) {
				this.tabType = "shop"
			} else if (
				currentOffsetTop >= fourthOffsetTop &&
				currentOffsetTop < fifthOffsetTop
			) {
				this.tabType = "source"
			} else if (currentOffsetTop >= fifthOffsetTop) {
				this.tabType = "auction"
			}
		},
		//滚动到指定位置
		scrollToElePosition(index) {
			const {first, second, third, fourth, fifth} = this.$refs
			// console.log(`滚动到指定位置${this.isSmoothScrolling}---------`);
			//记录当前滚动状态
			this.isSmoothScrolling = true
			//动画时间
			const SCROLL_DURATION = 500
			if (index == "shouye") {
				this.scrollToY(first.$el.offsetTop, SCROLL_DURATION)
			} else if (index == "activity") {
				this.scrollToY(second.$el.offsetTop, SCROLL_DURATION)
			} else if (index == "shop") {
				this.scrollToY(third.$el.offsetTop, SCROLL_DURATION)
			} else if (index == "source") {
				this.scrollToY(fourth.$el.offsetTop, SCROLL_DURATION)
			} else if (index == "auction") {
				this.scrollToY(fifth.$el.offsetTop, SCROLL_DURATION)
			}
		},
		scrollToY(y, duration = 0, element = document.scrollingElement) {
			if (element.scrollTop == y) {
				return
			}
			const NUMBER_TWO = 2
			const cosParameter = (element.scrollTop - y) / NUMBER_TWO
			let scrollCount = 0
			let oldTimestamp = null
			const step = function (newTimestamp) {
				if (oldTimestamp !== null) {
					scrollCount += (Math.PI * (newTimestamp - oldTimestamp)) / duration
					if (scrollCount >= Math.PI) {
						element.scrollTop = y
						return
					}
					element.scrollTop =
						cosParameter + y + cosParameter * Math.cos(scrollCount)
				}
				oldTimestamp = newTimestamp
				window.requestAnimationFrame(step)
			}
			window.requestAnimationFrame(step)
		}
		//   // 当页码改变的时候滚动条重新到顶部
		//   pageChange() {
		//   //   this.$emit("page-change", page);
		//     this.scrollTop = 0;
		//     this.$el.querySelector(".el-table__body-wrapper").scrollTop=this.scrollTop

		//     // this.saveScroll();
		//   },

		//   // 这里如果直接赋值给this.$el.querySelector('.el-table__body-wrapper').scrollTop会失效，需要加上setTimeout才行。
		//   saveScroll() {
		//     this.$nextTick(() => {
		//         setTimeout(()=>{
		//           this.$el.querySelector(".el-table__body-wrapper").scrollTop=this.scrollTop;
		//         })
		//     });
		//   },
	},
	beforeDestroy() {
		document.removeEventListener("scroll", this.throttleScroll)
		// document.removeEventListener("touchmove");
	}
}
